import React, { useState, useEffect } from "react";
import MapWithMarker from "./map/MapWithMarker";
import { useTranslation } from "react-i18next";
import { roadmakerApi } from "../api/roadmakerApi";

export default function PaletteMaker({
  projectId,
  userData,
  userPack,
  setVisibleComponent,
  unsavedChangesRef,
}) {
  const { t } = useTranslation();
  const [projectDatas, setProjectDatas] = useState(null);

  useEffect(() => {
    const fetchProjectDatas = async () => {
      const project = await roadmakerApi.projects.get(projectId);
      setProjectDatas(project);
    };
    fetchProjectDatas();
  }, [projectId]);

  if (!projectDatas) {
    return <div>{t("loading")}</div>;
  }

  let titleOfProject = "";
  if (projectDatas) {
    titleOfProject = projectDatas.name;
  }

  return (
    <div className="container-fluid">
      <div
        className="row"
        style={{ textAlign: "center", backgroundColor: "#ecedf1" }}
      >
        {/* récuperer le titre du projet venant d'être créé */}
        <h1 className="titleProject">
          {" "}
          {t("title")}
          {titleOfProject}
        </h1>
      </div>
      <div className="row">
        <div className="col-md-12" style={{ overflow: "auto" }}>
          <MapWithMarker
            projectDatas={projectDatas}
            userData={userData}
            titleOfProject={titleOfProject}
            userPack={userPack}
            setVisibleComponent={setVisibleComponent}
            unsavedChangesRef={unsavedChangesRef}
          />
        </div>
      </div>
    </div>
  );
}
